<!-- Flash message -->
<div class="pt-flash" [class.pt-flash--success]="messageFlash.type === 'success'" [class.pt-flash--error]="messageFlash.type === 'error'" *ngIf="messageFlash">
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
    <path *ngIf="messageFlash.type === 'success'" d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline *ngIf="messageFlash.type === 'success'" points="22 4 12 14.01 9 11.01"/>
    <circle *ngIf="messageFlash.type === 'error'" cx="12" cy="12" r="10"/><line *ngIf="messageFlash.type === 'error'" x1="12" y1="8" x2="12" y2="12"/><line *ngIf="messageFlash.type === 'error'" x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
  {{ messageFlash.texte }}
</div>

<!-- KPIs tableau de bord -->
<div class="pt-kpis" *ngIf="tableauBord && !chargementBord">
  <div class="pt-kpi pt-kpi--blue">
    <span class="pt-kpi-val">{{ tableauBord.totalPartenaires || partenaires.length }}</span>
    <span class="pt-kpi-lbl">Partenaires</span>
  </div>
  <div class="pt-kpi pt-kpi--green">
    <span class="pt-kpi-val">{{ tableauBord.partenairesActifs || 0 }}</span>
    <span class="pt-kpi-lbl">Actifs</span>
  </div>
  <div class="pt-kpi pt-kpi--purple">
    <span class="pt-kpi-val">{{ formaterMontant(tableauBord.montantTotalGenereMois || 0) }}</span>
    <span class="pt-kpi-lbl">FCFA ce mois</span>
  </div>
  <div class="pt-kpi pt-kpi--orange">
    <span class="pt-kpi-val">{{ tableauBord.totalLivraisonsMois || 0 }}</span>
    <span class="pt-kpi-lbl">Livraisons ce mois</span>
  </div>
</div>

<!-- Entête page -->
<div class="pt-page-header">
  <div class="pt-page-title-row">
    <h2 class="pt-page-title">
      <i class="fal fa-handshake"></i>
      Partenaires &amp; sous-traitants
    </h2>
    <button class="pt-btn pt-btn--primary" (click)="nouveau()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
      Ajouter un partenaire
    </button>
  </div>

  <!-- Filtres -->
  <div class="pt-filtres">
    <div class="pt-search-wrap">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input class="pt-search" type="text" placeholder="Nom, immatriculation, contact…" [(ngModel)]="rechercheTexte" (input)="filtrer()">
    </div>
    <select class="pt-select" [(ngModel)]="filtreContrat" (change)="filtrer()">
      <option value="">Tous contrats</option>
      <option value="PAR_LIVRAISON">Par livraison</option>
      <option value="MENSUEL">Mensuel fixe</option>
      <option value="HYBRIDE">Hybride</option>
    </select>
    <select class="pt-select" [(ngModel)]="filtreStatut" (change)="filtrer()">
      <option value="">Tous statuts</option>
      <option value="actif">En service</option>
      <option value="inactif">Hors service</option>
    </select>
    <button class="pt-btn pt-btn--ghost" (click)="reinitialiserFiltres()" *ngIf="rechercheTexte || filtreContrat || filtreStatut">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      Réinitialiser
    </button>
  </div>
</div>

<!-- Chargement -->
<div class="pt-loading" *ngIf="chargement">
  <div class="pt-spinner"></div>
  <span>Chargement des partenaires…</span>
</div>

<!-- Tableau -->
<div class="pt-table-wrap" *ngIf="!chargement">
  <div class="pt-empty" *ngIf="partenairesAffiches.length === 0">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48">
      <circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/>
    </svg>
    <p>Aucun partenaire trouvé.</p>
    <button class="pt-btn pt-btn--primary" (click)="nouveau()">Ajouter le premier partenaire</button>
  </div>

  <table class="pt-table" *ngIf="partenairesAffiches.length > 0">
    <thead>
      <tr>
        <th>Propriétaire</th>
        <th>Véhicule</th>
        <th>Contrat</th>
        <th>Livraisons/mois</th>
        <th>Montant dû</th>
        <th>Statut</th>
        <th class="pt-th-actions">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let p of partenairesAffiches">
        <td>
          <div class="pt-owner">
            <div class="pt-owner-avatar">{{ (p.nomProprietaire || '?')[0].toUpperCase() }}</div>
            <div class="pt-owner-info">
              <span class="pt-owner-name">{{ p.nomProprietaire || 'N/A' }}</span>
              <span class="pt-owner-contact">{{ p.contactProprietaire || '' }}</span>
            </div>
          </div>
        </td>
        <td>
          <div class="pt-vehicule">
            <span class="pt-vehicule-immat">{{ p.immatriculation }}</span>
            <span class="pt-vehicule-info">{{ p.marque }} {{ p.modele }}</span>
          </div>
        </td>
        <td>
          <span class="pt-badge"
            [class.pt-badge--blue]="p.typeContrat === 'PAR_LIVRAISON'"
            [class.pt-badge--purple]="p.typeContrat === 'MENSUEL'"
            [class.pt-badge--orange]="p.typeContrat === 'HYBRIDE'">
            {{ libelleContrat(p.typeContrat) }}
          </span>
          <div class="pt-contrat-detail" *ngIf="p.typeContrat === 'PAR_LIVRAISON' && p.montantParLivraison">
            {{ formaterMontant(p.montantParLivraison) }} FCFA/livraison
          </div>
          <div class="pt-contrat-detail" *ngIf="p.typeContrat === 'MENSUEL' && p.montantMensuel">
            {{ formaterMontant(p.montantMensuel) }} FCFA/mois
          </div>
        </td>
        <td class="pt-td-center">
          <span class="pt-livraisons-count">{{ p.livraisonsMois || 0 }}</span>
        </td>
        <td>
          <span class="pt-montant-du">{{ formaterMontant(montantDu(p)) }} FCFA</span>
        </td>
        <td>
          <span class="pt-statut" [class.pt-statut--actif]="p.enService" [class.pt-statut--inactif]="!p.enService">
            <span class="pt-statut-dot"></span>
            {{ p.enService ? 'En service' : 'Hors service' }}
          </span>
        </td>
        <td class="pt-td-actions">
          <button class="pt-action-btn pt-action-btn--edit" title="Modifier" (click)="modifier(p)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
          </button>
          <button class="pt-action-btn"
            [class.pt-action-btn--pause]="p.enService"
            [class.pt-action-btn--play]="!p.enService"
            [title]="p.enService ? 'Mettre hors service' : 'Remettre en service'"
            (click)="toggleService(p)">
            <svg *ngIf="p.enService" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15">
              <rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/>
            </svg>
            <svg *ngIf="!p.enService" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15">
              <polygon points="5 3 19 12 5 21 5 3"/>
            </svg>
          </button>
          <button class="pt-action-btn pt-action-btn--cloture" title="Clôture mensuelle" (click)="demanderCloture(p.id!)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
          </button>
          <button class="pt-action-btn pt-action-btn--delete" title="Supprimer" (click)="demanderSuppression(p)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15">
              <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
              <path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/>
            </svg>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Modal clôture mensuelle -->
<div class="pt-modal-overlay" *ngIf="confirmeClotureId !== null" (click)="annulerCloture()">
  <div class="pt-modal" (click)="$event.stopPropagation()">
    <div class="pt-modal-icon pt-modal-icon--orange">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="28" height="28">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
    </div>
    <h3 class="pt-modal-title">Clôture mensuelle</h3>
    <p class="pt-modal-body">Cette action va remettre les compteurs de livraisons et montants à zéro pour ce mois. Êtes-vous sûr ?</p>
    <div class="pt-modal-actions">
      <button class="pt-btn pt-btn--ghost" (click)="annulerCloture()">Annuler</button>
      <button class="pt-btn pt-btn--orange" (click)="confirmerCloture()">Confirmer la clôture</button>
    </div>
  </div>
</div>

<!-- Modal suppression -->
<div class="pt-modal-overlay" *ngIf="confirmeSuppression" (click)="annulerSuppression()">
  <div class="pt-modal" (click)="$event.stopPropagation()">
    <div class="pt-modal-icon pt-modal-icon--red">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="28" height="28">
        <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
      </svg>
    </div>
    <h3 class="pt-modal-title">Supprimer le partenaire</h3>
    <p class="pt-modal-body">Supprimer <strong>{{ confirmeSuppression.nomProprietaire }}</strong> — <em>{{ confirmeSuppression.immatriculation }}</em> ? Cette action est irréversible.</p>
    <div class="pt-modal-actions">
      <button class="pt-btn pt-btn--ghost" (click)="annulerSuppression()">Annuler</button>
      <button class="pt-btn pt-btn--danger" (click)="confirmerSuppression()">Supprimer</button>
    </div>
  </div>
</div>
